<template>
    <DisplayAccuracy :value="props.value?.Accuracy ?? null" />
</template>
<script setup lang="ts">
import DisplayAccuracy from '@/components/Basic/DisplayAccuracy.vue';
import type { MapPoint, TrackingDeviceWithRaceContestantPosition } from '@/objects/generated';

/**
 * This wrap the battery display so we can hide it on null
 */

const props = defineProps<{
    /**
     * The battery level in percent
     */
    value: MapPoint | null;

    /**
     * The entire datarow
     */
    row?: TrackingDeviceWithRaceContestantPosition | null;
}>();
</script>
